enum DmObjectType {
	Repository = 0,
	Folder = 1,
	File = 2,
	Content = 3,
	Shortcut = 4,
	Uploading = 5
}

export { DmObjectType };
